<template>
  <div class="col-12 theiaStickySidebar">
        <div class="settings-sidebar">
          <h4>Data import</h4>
          <div class="row">
          <div class="col-2"></div>
            <div class="col text-center p-2">
              <router-link :to="{path:'/data-import/import-data-status', query :{showAssignData:show_assign_data}}">Status</router-link>
            </div>
            <div class="col text-center p-2">
              <router-link  :to="{ path: '/data-import/upload-file', query: { fileId: file_id, useMapping: mapping_id, showAssignData:show_assign_data } }">Upload File</router-link>
            </div>
            <div class="col text-center p-2">
              <router-link  :to="{ path: '/data-import/validate', query: { fileId: file_id, useMapping: mapping_id, showAssignData:show_assign_data } }">Validate</router-link>
            </div>
            <!-- <div class="col text-center p-2">
              <router-link :to="{ path: '/data-import/create-mode', query: { fileId: file_id, useMapping: mapping_id }}">Create Mode</router-link>
            </div> -->
            <div class="col text-center p-2">
              <router-link  :to="{ path: '/data-import/map-data', query: { fileId: file_id, useMapping: mapping_id, showAssignData:show_assign_data } }">Map Data</router-link>
            </div>
            <!-- {{ typeof show_assign_data }} -->
            <div class="col text-center p-2" v-if="show_assign_data === 'true'">
              <router-link  :to="{ path: '/data-import/assign-data', query: { fileId: file_id, useMapping: mapping_id, showAssignData:show_assign_data } }">Assign Data</router-link>
            </div>
            <div class="col text-center p-2">
              <router-link :to="{ path: '/data-import/create-mode', query: { fileId: file_id, useMapping: mapping_id, showAssignData:show_assign_data }}">Create Mode</router-link>
            </div>
            <div class="col-2"></div>
          </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    file_id: String,
    mapping_id: String,
    show_assign_data: {
      type: String,
      default:"true"
    }
  },
};
</script>
<style scoped lang="scss">
 .settings-sidebar{
  .col:has(.active){
    border-bottom: 4px solid #E41F07;
    .active{
      color: #E41F07;
    }
  }
 }
</style>